import { useEffect, useMemo } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { OrderConversionRequestParams } from 'config/requests/orderConversion';
import { useQueryFilters } from 'hooks/useQueryFilters';
import isEqual from 'lodash/isEqual';
import { ConversionPeriod } from 'pages/Monitoring/OrderConversion/OrderConversionList/OrderConversionListPeriodToggle/OrderConversionListPeriodToggle';
import { Identifier } from 'react-admin';
import { useFilters } from 'shared/mui/Filter/hooks/useFilters';
import { getId } from 'utils';
import { cleanEmpty } from 'utils/cleanEmpty';
import * as yup from 'yup';

export type OrderConversionListFormValues = {
  merchant: string | null;
  gateway: string[];
  provider: string[];
  period: ConversionPeriod;
  direction: string | null;
};

const INITIAL_FILTERS = {
  merchant: null,
  gateway: [],
  provider: [],
  direction: null,
};

export const useOrderConversionFilter = () => {
  const { setQueryFilterString, queryFilterObject } = useQueryFilters();

  const { form, onSubmit, onReset, appliedFilters, setAppliedFilter, openDrawer, toggleDrawer } =
    useFilters<OrderConversionListFormValues>({
      resolver: yupResolver<any>(
        yup.object().shape({
          merchant: yup.string().required('Обязательное поле'),
        }),
      ),
      defaultValues: { ...INITIAL_FILTERS, ...queryFilterObject },
      resetValues: INITIAL_FILTERS,
    });

  const period = appliedFilters.period || ConversionPeriod.Hour12;

  const setPeriod = (value: ConversionPeriod) => {
    setAppliedFilter('period', value);
  };

  const params = useMemo<OrderConversionRequestParams>(() => {
    return cleanEmpty({
      gatewayIds: appliedFilters?.gateway?.map((hydraId) => getId(hydraId)),
      providerIds: appliedFilters?.provider?.map((hydraId) => getId(hydraId)),
      period,
      merchantId: getId(appliedFilters?.merchant as Identifier),
      direction: appliedFilters?.direction,
    }) as OrderConversionRequestParams;
  }, [period, appliedFilters]);

  useEffect(() => {
    const nextQueryFilter = cleanEmpty(appliedFilters);

    if (!isEqual(nextQueryFilter, cleanEmpty(queryFilterObject))) {
      setQueryFilterString(nextQueryFilter);
    }
  }, [appliedFilters]);

  const isListFilterExist = Object.keys(cleanEmpty(appliedFilters)).length > 0;

  return {
    params,
    form,
    setPeriod,
    onSubmit,
    toggleDrawer,
    isListFilterExist,
    period,
    openDrawer,
    appliedFilters,
    setAppliedFilter,
    onReset,
  };
};
